var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConditionalBlockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7175 15.8558L20.7175 18.7425L15.7175 21.6293V19.472L11.5793 19.2425V18.2425C11.5793 18.2425 14.115 18.1046 15.7397 18.0162C15.7311 17.1725 15.7175 15.8558 15.7175 15.8558Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20974 8.18033L2.63086 11.7592L6.20974 15.3381L9.0617 12.4861H10.4375V18.3186V19.4695H15.2872L15.7175 19.472L11.5793 19.2425V18.2425C11.5793 18.2425 14.115 18.1046 15.7397 18.0162C15.5791 18.016 15.3285 18.0156 15.3285 18.0156H11.8888L11.8913 17.5119V5.9759L15.7175 5.97561L15.7175 8.14423L20.7175 5.25748L15.7175 2.37073V4.53324L10.4375 4.53056V11.0323H9.0617L6.20974 8.18033Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConditionalBlockIcon);
export default __webpack_public_path__ + "static/media/conditional_block_icon.599970d7.svg";
export { ForwardRef as ReactComponent };